import React, { useState, useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css'; // AOS styles
import './OurServices.css';
import CarSlider from '../CarSlider/CarSlider';

const services = [
  {
    id: 1,
    title: 'Private Transfer',
    image: '/assets/service1.jpg',
  },
  {
    id: 2,
    title: 'Corporate Car Rental',
    image: '/assets/swift.png',
  },
  {
    id: 3,
    title: 'Car Rental with Driver',
    image: '/assets/ciaz.png',
  },
];

const OurServices = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <>
    <section id='ourservices' className="services-section">
      <div className="text-center mb-5">
        <p className="subtitle">WHAT WE DO</p>
        <h2 className="main-title">Our <span>Services</span></h2>
      </div>

      <div className="services-grid">
        {services.map((service, index) => (
          <div
            key={service.id}
            className="service-card"
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-offset="200"
          >
            <div
              className="service-image"
              style={{ backgroundImage: `url(${service.image})` }}
            ></div>
            <div className={`service-number ${hoveredIndex === index ? 'active' : ''}`}>
              {String(service.id).padStart(2, '0')}
            </div>
            <div className="service-title">
              {service.title}
            </div>
          </div>
        ))}
      </div>
    </section>
    <CarSlider />
    </>
  );
};

export default OurServices;
